// css =>
import "../../BaseStructure.css";
import Styled from "./Analys.module.css";

// pictures =>
import FarazLogo from "../../Assets/Logo/Faraz.jpg";
import ProjectLogo from "../../Assets/Logo/Livora.jpeg";
import cardImage from '../../Assets/Pictures/کارت_ویزیت_لیوورا.jpg';

// api =>
import backEnd from "../../store/Api";

// react =>
import { useState, useEffect } from "react";

// Componenets =>
import Fotter from "../../Components/Fotter/Fotter";
import { confirmDialog } from "../../Components/PopUp/PopUp";
import SpinnerBar from "../../Components/SpinnerBar/SpinnerBar";

function Analys() {

    const [isLoading, setIsLoading] = useState(false);
    const [ inputCode, setInputCode ] = useState(null);

    const [resultName, setResultName] = useState(null);
    const [resultLatsName, setResultLatsName] = useState(null);
    const [resultAge, setResultAge] = useState(null);
    const [resultJob, setResultJob] = useState(null);
    const [analysResult, setAnalysResult] = useState(null);

    useEffect(() => {
        setIsLoading(true);

        document.title = "رهگیری آنالیز | لیوورا";

        setInputCode(document.querySelector('input[name="Code"]'));

        setIsLoading(false);
    }, [])

    const AnalysisCalculator = async () => {
        setIsLoading(true);

        let tittle = "موفق";
        let status = "info";
        let message = "";
        let resultTextColor = "green";

        if (inputCode.value) {
            await backEnd.get(`/users/get-analyze/?trackingcode=${inputCode.value}`).then((result) => {
                status = "info";
                tittle = "موفق";
                resultTextColor = "green";
                message = result.data.score_tittle;

                setResultName(result.data.name);
                setResultLatsName(result.data.last_name);
                setResultAge(result.data.age);
                setResultJob(result.data.job);

                setAnalysResult(result.data.analyze);

                message += `همراه جدید خانواده بزرگ لیوورا، به جمع لیوورایی‌ها خوش آمدید.
                    نتیجه‌ی ارزشیابی پرونده شما آماده شد. این آنالیز بر اساس اطلاعاتی است که وارد کرده‌اید و به‌صورت کلی، نقاط قوت و ضعف پرونده شما از نگاه آفیسر ویزا را تا حدی مشخص می‌کند.

                    در مرحله بعد، تیم لیوورا با بررسی تخصصی‌تر و دقیق‌تر پرونده‌ی شما تلاش می‌کند:
                    - امتیازهای منفی را تا حد امکان به نقاط قابل اصلاح و مثبت تبدیل کند  
                    - امتیازهای مثبت را تقویت کند  
                    - مسیر اقدام را با توجه به شرایط شما شفاف و امن طراحی کند

                    برای دریافت مشاوره و ادامه‌ی فرآیند، از راه‌های زیر در ارتباط باشید:

                    وب‌سایت:
                    <a href="https://www.livoravisa.com" target="_blank">www.livoravisa.com</a>

                    اینستاگرام:
                    <a href="https://www.instagram.com/livoravisaco?igsh=ZnJvM2UxazVxMG1y" target="_blank">instagram.com/livoravisaco?igsh=ZnJvM2UxazVxMG1y</a>

                    ارتباط مستقیم با مشاور (تماس / واتساپ / تلگرام):
                    09002799993

                    دفاتر لیوورا:
                    04433226900
                    04433226800
                    04432244099
                    02188997078
                    02188997079

                    مراجعه حضوری:
                    ارومیه ، خیابان والفجر ، نبش طاها ، برج رایان ، طبقه آخر ، واحد یک

                    <a href="${ cardImage }" download="کارت_ویزیت_لیوورا.jpg" style="color:#007bff; text-decoration:underline;">دانلود کارت ویزیت</a>`;
            }).catch((error) => {
                status = "error";
                tittle = "خطا";
                resultTextColor = "red";
                message = error.message;
                message += "!لطفا دقایقی دیگر مجددا تلاش کنید";
            })

            setIsLoading(false);
            const showDialog = await confirmDialog(
                message,
                status,
                `نتیجه آنالیز شما: ${tittle}`,
                resultTextColor,
                '#1f2937'
            );
        }
    }

    return (
        <>
            {
                isLoading ? <SpinnerBar /> : (
                    <>
                        <div className="row">
                            <div className="col-12" id={ Styled.FistTittleFrame }>
                                <img src={ ProjectLogo } alt="Livora" />
                                <img src={ FarazLogo } alt="Livora" />
                            </div>
                        </div>

                        <div className={`row ${ Styled.AnalysFormFrame }`}>
                            <div className="col-1"><hr /></div>
                            <div className="col-2">
                                <h3>آنالیز</h3>
                            </div>
                            <div className="col-9"><hr /></div>
                        </div>

                        <br /><br />

                        <div className="row">
                            <div className="col-2" id={ Styled.EnterCodeText }>
                                <h4>کد اشتراک خود را وارد کنید:</h4>
                            </div>
                            <div className={`col-8 ${ Styled.InputsCodeFrame }`}>
                                <input type="text" name="Code" placeholder="کد اشتراک" />
                            </div>
                            <div className="col-2" id={ Styled.CodeButton }>
                                <button onClick={ AnalysisCalculator }>آنالیز</button>
                            </div>
                        </div>

                        <div className="row" id={ Styled.TicketSendFormFrame }>
                            <div className="col-12">
                                <p id={ Styled.NewTicketText }>آنالیز</p>
                                <hr />
                            </div>

                            <div className={`col-6 ${ Styled.BaseUserInfoFrame }`}>
                                <p>نام:</p>
                                <input type="text" className={ Styled.BaseUserInfo } placeholder={ resultName } disabled />
                            </div>
                            <div className={`col-6 ${ Styled.BaseUserInfoFrame }`}>
                                <p>نام خانوادگی:</p>
                                <input type="text" className={ Styled.BaseUserInfo } placeholder={ resultLatsName } disabled />
                            </div>

                            <div className={`col-6 ${ Styled.TwoiceInfoFrame }`}>
                                <p>سن:</p>
                                <input type="text" placeholder={ resultAge } disabled />
                            </div>
                            <div className={`col-6 ${ Styled.TwoiceInfoFrame }`} style={{ marginBottom: '5%' }}>
                                <p>شغل:</p>
                                <input type="text" placeholder={ resultJob } disabled />
                            </div>

                            <div className="col-12">
                                <p style={{ marginRight: '2.5%' }}>نتیجه آنالیز:</p>
                                <textarea id='TicketBody' name="TicketTextReceived" disabled>{ analysResult }</textarea>
                            </div>

                            <div className={`col-6 ${ Styled.ButtonFrame }`}>
                                <button className={ Styled.SendBtn } id="SendBtnDOM" onClick={() => {
                                    window.location.reload();
                                }}>
                                    <h3>خواندم</h3>
                                </button>
                            </div>

                            <div className={`col-6 ${ Styled.ButtonFrame }`}>
                                <button id={ Styled.CancleBtn }>
                                    <h3>بازگشت</h3>
                                </button>
                            </div>
                        </div>

                        <br /><br />
                    </>
                )
            }

            <Fotter />
        </>
    );
}

export default Analys;
